import { Route } from "react-router-dom";
import FranchiseDashboard from "../../screens/franchise/FranchiseDashboard";
import FranchisePayouts from "../../screens/franchise/FranchisePayouts";

export const franchiseRoutes = [
  <Route key="franchise-dashboard" path="/" element={<FranchiseDashboard />} />,
  <Route
    key="franchise-payouts"
    path="/payouts"
    element={<FranchisePayouts />}
  />,
];
